import { z } from "zod";
const point = z.strictObject({ x: z.number().finite(), y: z.number().finite() });
const token = z.string().regex(/^[a-z][a-z0-9.-]*$/u);
/** V07: a visual specification lives with the existing pack, never in a second catalogue. */
export const VisualProfileSchema = z.strictObject({
    id: token,
    version: z.literal(1),
    references: z.array(z.strictObject({ path: z.string().min(1), sha256: z.string().regex(/^[a-f0-9]{64}$/u) })).min(1).max(6),
    palette: z.array(z.string().regex(/^#[a-fA-F0-9]{6}$/u)).min(2).max(12),
    paper: z.literal("scene-only"),
    grain: z.string().min(1),
    line: z.string().min(1),
    edgeSoftness: z.string().min(1),
    displayDetail: z.string().min(1),
    camera: z.literal("orthographic-elevation"),
    lighting: z.strictObject({ direction: z.enum(["left", "right", "above", "diffuse"]), softness: z.enum(["soft", "hard"]), surfaces: z.enum(["painted", "runtime"]) }),
    production: z.literal("shared-master-registered-layers"),
});
export const IllustrationMetadataSchema = z.strictObject({
    version: z.literal(1),
    profile: token,
    layer: z.enum(["background", "architecture", "rear", "actor", "foreground", "light"]),
    shadow: z.enum(["painted", "runtime", "none"]),
    nativeFacing: z.enum(["left", "right", "none"]),
    mirroring: z.enum(["safe", "forbidden"]),
    identity: z.string().min(1).optional(),
    wardrobe: z.string().min(1).optional(),
    pose: token.optional(),
    compatiblePoses: z.array(token).max(12),
    contacts: z.array(point.extend({ id: token, kind: z.enum(["ground", "seat", "hand", "tabletop"]) })).max(12),
    occlusion: z.enum(["silhouette", "opaque-surface", "glass"]),
    /** Display-only treatment; source paintings stay byte-identical. */
    treatment: z.enum(["monochrome", "monochrome-cutout"]).optional(),
});
/** Pixel coordinates into a shared source painting. Rendered by a canonical SVG polygon. */
export const RasterRegistrationSchema = z.strictObject({
    window: z.strictObject({ x: z.number().nonnegative(), y: z.number().nonnegative(), w: z.number().positive(), h: z.number().positive() }),
    mask: z.array(point).min(3).max(256),
    /** Separate silhouette pieces keep open gaps between foliage, handles and branches. */
    fragments: z.array(z.array(point).min(3).max(256)).max(64).optional(),
});
//# sourceMappingURL=illustration.js.map